<app-cps-tab-bar></app-cps-tab-bar>

<div class="wrapper doc-content-wrapper container-fluid">
    <span class="header-text">{{ 'Error.wereSorry' | translate }}</span>
    <span class="body-text">{{ 'Error.pageNotFound' | translate }}</span>
</div>
